import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const descriptionBodyStyles = xcss({
	font: 'font.body',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	display: '-webkit-box',
	WebkitLineClamp: 2,
	lineClamp: 2,
	WebkitBoxOrient: 'vertical',
});

type DescriptionBodyProps = {
	description: ReactNode;
};

export const DescriptionBody = ({ description }: DescriptionBodyProps): React.JSX.Element => {
	return <Box xcss={descriptionBodyStyles}>{description}</Box>;
};
